import { getCurrentMagentoClient } from "@magento/clients/getClient";
import type { IGetPromotionalOffersQuery } from "@magento/types";

import { useQuery } from "@jti/rest-api";

export type UseProductPromotionalOffersQueryOptions = {
  sku: string;
  pageSize?: number;
  isTrial?: boolean;
};

export const useProductPromotionalOffersQuery = ({
  sku,
  pageSize = 1,
  isTrial = false,
}: UseProductPromotionalOffersQueryOptions) => {
  const magentoClient = getCurrentMagentoClient(isTrial);

  return useQuery<IGetPromotionalOffersQuery>({
    queryKey: ["PROMOTIONAL_OFFERS", sku, { isTrial }],
    queryFn: () => magentoClient.getPromotionalOffersBySku([sku], pageSize),
  });
};
